import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import AppRouter from './AppRouter';
import Header from './component/Header';
import Footer from './component/Footer';
import AuthModals from "./component/AuthModals";
import RegisterInterestModal from "./component/RegisterInterestModal";
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './context/AuthContext';
import { LocationProvider } from './context/LocationContext';
import { CartProvider } from "./context/CartContext";
import { CartDrawerProvider } from './context/CartDrawerContext';
import CartDrawer from './component/CartDrawer';

const App = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalClosedManually, setModalClosedManually] = useState(false);
  const location = useLocation();

  const isSchoolRoute = location.pathname.startsWith('/school');
  const isVendorRoute = location.pathname.startsWith('/vendor');
  const isAgentRoute = location.pathname.startsWith('/agent');
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    // Only show modal on home page if not manually closed
    if (isHomePage && !modalClosedManually) {
      const timer = setTimeout(() => {
        setShowModal(true);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isHomePage, modalClosedManually]);

  // Close modal when navigating away from home page or to school/vendor routes
  useEffect(() => {
    if ((!isHomePage || isSchoolRoute || isVendorRoute || isAgentRoute) && showModal) {
      setShowModal(false);
    }
  }, [isHomePage, isSchoolRoute, isVendorRoute, isAgentRoute, showModal]);

  const handleCloseModal = () => {
    setShowModal(false);
    setModalClosedManually(true);
  };

  const handleOpenModal = () => {
    setShowModal(true);
    setModalClosedManually(false);
  };

  return (
    <>
      {/* Show register footer button on home page when modal isn't shown */}
      <AuthProvider>
        <LocationProvider>
          <CartProvider>
            <CartDrawerProvider>
            {isHomePage && !showModal && (
              <div className="register-footer">
                <button
                  className="theme-btn btn-one"
                  onClick={handleOpenModal}
                >
                  Register Your Interest+
                </button>
              </div>
            )}

            {/* Show modal only on home page */}
            {isHomePage && (
              <RegisterInterestModal
                show={showModal}
                onClose={handleCloseModal}
              />
            )}

            <AuthModals
              showLogin={showLogin}
              showRegister={showRegister}
              onCloseLogin={() => setShowLogin(false)}
              onCloseRegister={() => setShowRegister(false)}
              openRegisterFromLogin={() => {
                setShowLogin(false);
                setShowRegister(true);
              }}
              openLoginFromRegister={() => {
                setShowRegister(false);
                setShowLogin(true);
              }}
            />

            {/* Don't show header on school/vendor/agent routes */}
            {!isSchoolRoute && !isVendorRoute && !isAgentRoute && <Header onLoginClick={() => setShowLogin(true)} />}

            <AppRouter />
            <CartDrawer />
            {!isSchoolRoute && !isVendorRoute && !isAgentRoute && <Footer />}

            </CartDrawerProvider>
          </CartProvider>
        </LocationProvider>
      </AuthProvider>
    </>
  );
};

export default App;
